import EmberObject from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class DealAdapter extends EmberObject {
  @service declare ajax

  find(ids = []) {
    return this.ajax.requestFromAdapter(ENV.API_ROOT + "/deals/" + ids.join(","))
  }
}
